import { useState } from 'react';
import { useUid } from '../../../../../../../common/utils/uid/index.tsx';
import { useFormContext } from '../../../../../../../controllers/form/index.tsx';
import type {
	DefaultWorkingTime,
	DefaultWorkingTimes,
	DefaultWorkingTimeWithFieldIds,
} from './types';

export const UseWorkingTimesState = (
	defaultWorkingTimes: DefaultWorkingTimes | null | undefined,
	defaultWorkHours: DefaultWorkingTime,
) => {
	const [getUid] = useUid();

	const [, { setFormStatusToDirty }] = useFormContext();

	const [isDaySelected, setDaySelected] = useState<boolean>(Boolean(defaultWorkingTimes));

	const [workingTimes, setWorkingTimes] = useState<DefaultWorkingTimeWithFieldIds>(() =>
		(defaultWorkingTimes || [defaultWorkHours]).map((defaultWorkingTime) => ({
			...defaultWorkingTime,
			fieldId: getUid(),
		})),
	);

	const onRemove = (id: number) => {
		setWorkingTimes(workingTimes.filter(({ fieldId }) => fieldId !== id));
		setFormStatusToDirty();
	};

	const onAdd = () => {
		setWorkingTimes([...workingTimes, { ...defaultWorkHours, fieldId: getUid() }]);
		setFormStatusToDirty();
	};

	return [
		{
			workingTimes,
			isDaySelected,
		},
		{
			onRemove,
			onAdd,
			setDaySelected,
		},
	] as const;
};
